import { ITextInputProps, TextInput } from '../TextInput';
import { ZipCodeMask } from './ZipCodeMask';

export const ZipCodeInput = (props: ITextInputProps) => (
  <TextInput {...props} fullWidth InputProps={{ inputComponent: ZipCodeMask }} />
);
